import { Toast, ToastMessage } from "primereact/toast";
import React from "react";

/** Reads validation/error text from API error bodies (camelCase or PascalCase). */
export const getApiErrorMessage = (error: unknown): string | null => {
  if (typeof error !== "object" || error === null || !("response" in error)) {
    return null;
  }

  const data = (error as { response?: { data?: Record<string, unknown> } }).response
    ?.data;
  if (!data || typeof data !== "object") {
    return null;
  }

  const message = data.message ?? data.Message;
  return typeof message === "string" && message.trim() !== "" ? message : null;
};

export const showMessage = (
  toastRef: React.RefObject<Toast>,
  severity: ToastMessage["severity"],
  message: string,
): void => {
  toastRef.current?.show({
    severity: severity,
    summary: "Neue Nachricht",
    detail: message,
    life: 3000,
  });
};
